import { render, staticRenderFns } from "./commonOrder.vue?vue&type=template&id=7be2147b&scoped=true"
import script from "./commonOrder.vue?vue&type=script&lang=js"
export * from "./commonOrder.vue?vue&type=script&lang=js"
import style0 from "./commonOrder.vue?vue&type=style&index=0&id=7be2147b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2147b",
  null
  
)

export default component.exports